export const breakpoints = {
  "xs-phone": 374,
  "phone": 575,
  "tablet-landscape": 1112,
  "small-desktop": 1200,
  "tablet": 834,
};
